import React, { FunctionComponent, useEffect, useState } from 'react'
import classnames from 'classnames'
import { useHistory } from 'react-router-dom'
import localforage from 'localforage'
import moment from 'moment'
import { useGetLatestReleaseNoteQuery } from '../../generated/types'
import { get } from 'lodash'

import style from './style.module.css'

const ReleaseNotesIndicator: FunctionComponent = () => {
  const { data, loading, error } = useGetLatestReleaseNoteQuery()

  const history = useHistory()

  const [notify, setNotify] = useState(false)

  useEffect(() => {
    if (error || loading) {
      return
    }

    const latest = get(data, 'releaseNotes.page[0].insertedAt', 0)

    localforage.getItem<string>('rvmn:release_notes').then(lastViewed => {
      const shouldNotify = lastViewed
        ? moment(latest).isAfter(moment(lastViewed))
        : true

      setNotify(shouldNotify)
    })
  }, [data])

  return (
    <div className={style.container}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <span
        onClick={() => {
          setNotify(false)
          history.push('/app/release-notes')
        }}
        className={classnames('material-icons', style.releaseNotes, {
          [style.notify]: notify,
        })}
      >
        notifications
      </span>
    </div>
  )
}

export default ReleaseNotesIndicator
